// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"6fee728f","803":"ab52f560"}[chunkId] + ".chunk.js";
};